import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
/* Components */
import { CheckboxGroupV2, CheckboxV2 } from 'src/components/HTKit/Forms/CheckboxV2';
import { isPartnerSubsidizedAddOn } from 'src/components/PreQuestion/utils';
import { ErrorMsg } from 'src/components/HTKit/Forms/Parts';
import PreQuestionLabelWithHint from '../PreQuestionLabelWithHint';
import CheckboxQuantitySelector from './CheckboxQuantitySelector';
import styles from '../styles.scss';

const PreQuestionCheckbox = ({ question, value, onChange, sku, error, onQuantityChange }) => {
  const handleQuantityChange = (answer, val) => {
    onQuantityChange({ id: answer.get('id'), quantity: val });
  };

  const values = (value && value.toJS().map((v) => v.id)) || [];
  const containerStyles = cn({
    [styles.preQuestionCheckboxError]: error,
  });

  /**
   * For legacy reasons the original state of answer.adjAmountFormatted is an object with the shape
   * {value: number, formatted: string}. The addSkuPage/UPDATE_SKU_QUESTIONS action fires, and then
   * answer.adjAmountFormatted is turned into a string
   */
  const getAnswerAdjAmountFormatted = (answer) => {
    const adjAmountFormatted = answer.get('adjAmountFormatted');
    if (typeof adjAmountFormatted === 'string') return adjAmountFormatted;
    return adjAmountFormatted.get('formatted');
  };

  return (
    <>
      <div className={containerStyles}>
        <CheckboxGroupV2
          value={values}
          label={question.get('textDirect')}
          onChange={onChange}
          disableSort
          disableGrouping
        >
          {question.get('answers').map((answer, i) => {
            let label = answer.get('text');
            if (answer.get('adjAmountFormatted')) {
              const amountFormatted = getAnswerAdjAmountFormatted(answer);
              const partnerText = isPartnerSubsidizedAddOn({ answer, sku })
                ? ` Paid by ${sku.getIn(['partner', 'name'], 'Partner')}`
                : '';
              label += ` (+${amountFormatted}${partnerText})`;
            }
            const selectedValue = value && value.find((v) => v.get('id') === answer.get('id'));
            const isAnswerWithHint = !!answer.get('warning');
            const showQuantitySelector = answer.get('hasQuantity') && selectedValue;
            const labelText = isAnswerWithHint ? (
              <PreQuestionLabelWithHint label={label} warning={answer.get('warning')} inlineIcon />
            ) : (
              label
            );
            return (
              <CheckboxV2
                value={answer.get('id')}
                label={labelText}
                key={`checkbox${i}`}
                wrapperClass="positionRelative"
                labelClass="width-full"
              >
                {showQuantitySelector && (
                  <CheckboxQuantitySelector
                    answer={answer}
                    selectedValue={selectedValue}
                    onChange={handleQuantityChange}
                  />
                )}
              </CheckboxV2>
            );
          })}
        </CheckboxGroupV2>
      </div>
      {error && <ErrorMsg error={error} />}
    </>
  );
};

PreQuestionCheckbox.propTypes = {
  question: PropTypes.object.isRequired,
  sku: PropTypes.object.isRequired,
  value: PropTypes.object,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
};

export default PreQuestionCheckbox;
